import { render, staticRenderFns } from "./Colonias.vue?vue&type=template&id=126623d0&scoped=true&"
import script from "./Colonias.vue?vue&type=script&lang=js&"
export * from "./Colonias.vue?vue&type=script&lang=js&"
import style0 from "./Colonias.vue?vue&type=style&index=0&id=126623d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126623d0",
  null
  
)

export default component.exports